import { Box } from "@mui/material";
import React from "react";
import PriceFormat from "./PriceFormat";

const isValue = (value?: number) => {
  return value !== undefined && value !== null;
};

export interface PriceRangeFormatProps {
  minValue?: number;
  maxValue?: number;
  className?: string;
  color?: string;
}

const PriceRangeFormat = ({ minValue, maxValue, className, color }: PriceRangeFormatProps) => {
  if (!isValue(minValue) && !isValue(maxValue)) {
    return <></>;
  }

  const isSingleValue = !isValue(minValue) || !isValue(maxValue) || minValue === maxValue;
  return (
    <Box className={className} color={color}>
      {isSingleValue ? (
        <PriceFormat value={isValue(minValue) ? minValue : maxValue} />
      ) : (
        <>
          <PriceFormat value={minValue} />-<PriceFormat value={maxValue} />
        </>
      )}
    </Box>
  );
};

export default PriceRangeFormat;